import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';
import { QuantiteDossierPrecontentieuxDTO } from '../../model/QuantiteDossierPrecontentieuxDTO';

@Injectable({
  providedIn: "root"
})
export class DashboardPreContentieuxService {
  constructor(private _restClientService: RestClientService) {}

  nombrePreContentieuxFiltrerSurPeriode(workflow, agency) {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-pre-contentieux/nombreDossier-preContentieux-filtrer-sur-periode?workflow=" +
        workflow +
        "&agency=" +
        agency
    );
  }

  quantitePreContentieuxSurLes6DerniersMois(workflow, agency) {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-pre-contentieux/quantite-dossier-creance-restructure-surLes6DerniersMois?workflow=" +
        workflow +
        "&agency=" +
        agency
    );
  }

  quantiteDossierPrecontentieux() {
    return this._restClientService.load<QuantiteDossierPrecontentieuxDTO[]>(
      "dashboard-pre-contentieux/historique-pre-contentieux"
    );
  }
}
